import { TextField } from '@material-ui/core';
import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import InputAdornment from '@material-ui/core/InputAdornment';

function renderPasswordToggle(passwordToggled, setPasswordToggled) {
  return (
    <IconButton tabIndex="-1" onClick={() => setPasswordToggled(!passwordToggled)}>
      {passwordToggled ? <Visibility /> : <VisibilityOff />}
    </IconButton>
  );
}

const FormPasswordField = React.forwardRef((props, ref) => {
  const [passwordToggled, setPasswordToggled] = useState(false);
  const { form, field, autoFocus, disabled, label, helperText } = props;
  
  const componentMeta = form.getFieldMeta(field.name);
  const componentDisabled = disabled || form.isSubmitting;
  const componentError = componentMeta.touched && !!componentMeta.error;
  const componentHelperText = (componentError && componentMeta.error) || helperText;
  
  return (
    <TextField
      ref={ref}
      type={passwordToggled ? 'text' : 'password'}
      variant="outlined"
      margin="normal"
      name={field.name}
      value={field.value}
      onBlur={field.onBlur}
      onChange={field.onChange}
      autoFocus={autoFocus}
      label={label}
      disabled={componentDisabled}
      error={componentError}
      helperText={componentHelperText}
      InputProps={{
        endAdornment: <InputAdornment position="end">
          {renderPasswordToggle(passwordToggled, setPasswordToggled)}
        </InputAdornment>,
      }}
    />
  );
});

export default FormPasswordField;
